/* tslint:disable:max-line-length */
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';
import { User } from '../../data-objects/user';
import { RefDataItem, RefDataType } from '../../data-objects/ref-data-item';
import { FormControl, Validators } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { RefDataDropdownComponent } from '../ref-data-dropdown/ref-data-dropdown.component';
import { RefDataService } from '../../services/ref-data.service';
import { PostalAddressComponent } from '../postal-address/postal-address.component';
import { LocationDetails } from '../../data-objects/location-details';
import { FeatureToggle } from '../../data-objects/feature-toggle';
import { FeatureToggleService } from '../../services/feature-toggle.service';
import { PostalAddress } from '../../data-objects/postal-address';

const numberRE = /^[0-9]*$/;
const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
const accountNoRE = /^999\d{8}$/;

@Component({
  selector: 'app-applicant-details',
  templateUrl: './applicant-details.component.html',
  styleUrls: ['./applicant-details.component.css']
})

export class ApplicantDetailsComponent implements OnInit {

  private static _isGuest: boolean;

  @Input()
  locationDetails: LocationDetails;
  @Input()
  public phoneMailLabel: 'Phone';
  @Input()
  applicantLabel = 'Applicant';
  @Input()
  applicantDetails: User;
  @Input()
  isReadOnly: boolean;
  @Input()
  isHydrant = false;
  @Input()
  isNonWorks = false;
  @Input()
  isWorks = false;
  @Output()
  selectedItemUpdated = new EventEmitter();

  @ViewChild('title') titles: RefDataDropdownComponent;
  @ViewChild('postalAddress') postalAddress: PostalAddressComponent;

  isLandLineMandatory: boolean;
  isMobileMandatory: boolean;
  items: RefDataItem[];

  emailControl: FormControl;
  consultantRefControl: FormControl;
  phoneNumberControl: FormControl;
  mobileNumberControl: FormControl;
  postalAddressControl: FormControl;

  abnNumberControl: FormControl;
  companyNameControl: FormControl;
  positionControl: FormControl;

  emailControlLength = 50;
  consultantRefControlLength: 20;
  abnNumberControlLength = 11;
  companyNameControlLength = 60;
  positionControlLength = 50;

  phoneNumberControlMaxLength = 10;
  mobileNumberControlMaxLength = 10;

  phoneNumberControlMinLength = 8;
  mobileNumberControlMinLength = 10;

  firstNameControlLength = 50;
  lastNameControlLength = 50;

  postalAddressControlLength = 200;

  firstNameControl: FormControl = new FormControl('');
  lastNameControl: FormControl = new FormControl('');
  accountNoControl: FormControl = new FormControl('');

  isRequesting: boolean;

  errorMessage: string;

  _feature: FeatureToggle;

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  constructor(private loginService: LoginService
    , private refDataService: RefDataService, private cdRef: ChangeDetectorRef, private featureToggleService: FeatureToggleService) {

    this.firstNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.firstNameControlLength)
    ])]);
    this.lastNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.lastNameControlLength)
    ])]);
    this.postalAddressControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.postalAddressControlLength)
    ])]);
    this.emailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.emailControlLength),
      Validators.pattern(emailRE)])
    ]);
    this.consultantRefControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.consultantRefControlLength)
    ])
    ]);
    this.phoneNumberControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.phoneNumberControlMaxLength),
      Validators.minLength(this.phoneNumberControlMinLength),
      Validators.pattern(numberRE),
      Validators.required
    ])]);

    this.mobileNumberControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.mobileNumberControlMaxLength),
      Validators.minLength(this.mobileNumberControlMinLength),
      Validators.pattern(numberRE),
      Validators.required
    ])]);

    this.abnNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.abnNumberControlLength)
    ])
    ]);

    this.positionControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.positionControlLength)
    ])
    ]);

    this.companyNameControl = new FormControl('', [
      Validators.maxLength(this.companyNameControlLength)
    ]);
  }

  async ngOnInit() {

    await this.getFeatureToggle();

    if (this.isHydrant) {
      const existingValidators = this.companyNameControl.validator;
      this.companyNameControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    }

    if (!this.isGuestUserLoggedIn()) {
      this.isLandLineMandatory = true;
      this.isMobileMandatory = false;
    } else {
      this.isLandLineMandatory = false;
      this.isMobileMandatory = true;
    }

    if (this.isGuestUserLoggedIn()) {
      this.getTitles();
    }

    const pleaseSelectConsultant: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Consultants, '').subscribe(
      (refDataItems) => {
        this.items = pleaseSelectConsultant.concat(refDataItems);
        for (let i = 0; i < this.items.length; i++) {
          if (this.applicantDetails.currentConsultantSelectedItemId === this.items[i].id) {
            this.selectedItemId = Number(this.items[i].id);
            break;
          }
        }
      },
      err => {
      });

    if (this.isTechCSOUserLoggedIn()) {
      this.accountNoControl = this._feature.DisableGuestUsers
        ? new FormControl('')
        : new FormControl('', [Validators.compose([Validators.required, Validators.pattern(accountNoRE)])]);

      this.accountNoControl.registerOnChange(() => {
        this.applicantDetails.postalAddress = this.applicantDetails.accountName = '';
      });
    } else {
      this.accountNoControl = new FormControl({
        value: '',
        disabled: true
      });
    }
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  private getTitles() {
    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Titles, '').subscribe(
      (refDataItems) => {
        if (this.titles) {
          this.titles.items = pleaseSelect.concat(refDataItems);
          if (this.applicantDetails) {
            for (let i = 0; i < this.titles.items.length; i++) {
              if (this.applicantDetails.title === this.titles.items[i].display) {
                this.titles.selectedItemId = this.titles.items[i].id;
                break;
              }
            }
          }
        }
      },
      err => {
      });
  }

  get selectedItemId(): number {
    return this.applicantDetails.currentConsultantSelectedItemId;
  }

  set selectedItemId(v: number) {
    this.applicantDetails.currentConsultantSelectedItemId = v;
  }

  public get selectedItem(): RefDataItem {
    if (this.items == null) {
      return null;
    }
    for (const i of this.items) {
      if (Number(i.id) === Number(this.selectedItemId)) {
        return i;
      }
    }
    return null;
  }

  public set selectedItem(theItem: RefDataItem) {
    if (theItem != null) {
      this.selectedItemId = Number(theItem.id);
    }
  }

  public onSelectedItemChange(event: any): void {
    this.selectedItemUpdated.emit(Number(this.selectedItem));
    this.companyName = this.selectedItem.display;
  }

  private get isPhoneNumberControlInvalid(): boolean {
    if (!this.phoneNumberControl.invalid) {
      return false;
    } else {
      return (this.phoneNumberControl.hasError('maxlength') ||
        this.phoneNumberControl.hasError('minlength') ||
        this.phoneNumberControl.hasError('required') && this.isLandLineMandatory ||
        this.phoneNumberControl.hasError('pattern'));
    }
  }

  private get isMobileNumberControlInvalid(): boolean {
    if (!this.mobileNumberControl.invalid) {
      return false;
    } else {
      return (this.mobileNumberControl.hasError('maxlength') ||
        this.mobileNumberControl.hasError('minlength') ||
        this.mobileNumberControl.hasError('required') && this.isMobileMandatory ||
        this.mobileNumberControl.hasError('pattern'));
    }
  }

  get invalid(): boolean {
    return (!this.isNonWorks && (this.emailControl.invalid || this.isPhoneNumberControlInvalid || this.isMobileNumberControlInvalid)) // Contact details are to be valid for everyone
      // ||  (this.isGuestUserLoggedIn() && !this.isNonWorks && // Guest user should have first/last name for all applications but non works etc.
      //     (this.firstNameControl.invalid || this.lastNameControl.invalid || this.companyNameControl.invalid))
      // ||  (this.isGuestUserLoggedIn() && !this.postalAddress.isValid) // Guest user should have postal address for all.
      ||  (this.isTechCSOUserLoggedIn() && // Tech CSO should populate and validate account number
          (!this.applicantDetails.accountNumber || !this.applicantDetails.postalAddress))
      ||  (this.applicantLabel === 'Consultant' && // Hydrant application should have consultant
          (this.applicantDetails.currentConsultantSelectedItemId === 0 || this.consultantRefControl.invalid)
          || (this.isHydrant && (this.abnNumberControl.invalid || this.positionControl.invalid)))
      ||  (!this.isValidStructuredPostal(this.applicantDetails.structuredPostal).status)
      // ||(this.isGuestUserLoggedIn() && !this.isNonWorks && (!this.titles.selectedItemId || this.titles.selectedItemId === '0'))  // Title is mandatory for the guest user
      ;
  }

  public handleTitleChanged($event) {
    const selectedItem: RefDataItem = this.titles.selectedItem;
    if (selectedItem) {
      this.applicantDetails.title = selectedItem.display;
    }
  }

  isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn() || ApplicantDetailsComponent._isGuest;
  }

  isTechCSOUserLoggedIn(): boolean {
    return this.loginService.isTechCSOUserLoggedIn() || this.loginService.isSystemAdminUserLoggedIn();
  }

  set selectedTitleId(v: string) {
    if (this.titles) {
      this.titles.selectedItemId = v;
    }
  }

  get companyName() {
    if (!this.applicantDetails) {
      return '';
    } else {
      return this.applicantDetails.accountName;
    }
  }

  set companyName(v: string) {
    if (this.applicantDetails) {
      this.applicantDetails.accountName = v;
    }
    if (v) {
      this.isLandLineMandatory = true;
      this.isMobileMandatory = false;
    } else {
      this.isLandLineMandatory = false;
      this.isMobileMandatory = true;
    }
  }

  onValidateClick() {
    ApplicantDetailsComponent._isGuest = false;
    this.isRequesting = true;
    this.errorMessage = '';
    this.loginService.verifyAccount(this.applicantDetails.accountNumber).subscribe((user: User) => {
      this.isRequesting = false;
      if (user == null) {
        this.errorMessage = 'Account does not exist';
      } else {
        this.applicantDetails.accountName = user.accountName;
        this.applicantDetails.postalAddress = user.postalAddress;
        if (user.isGuestUser) {
          ApplicantDetailsComponent._isGuest = true;
          this.getTitles();
          this.cdRef.detectChanges();
        }
      }
    }, err => {
      this.isRequesting = false;
      this.errorMessage = 'Account does not exist';
    });
  }

  isValidStructuredPostal (structuredPostal: PostalAddress): { status: boolean, msg: string } {

    const postcodeRE = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;
    let validPostcode: boolean = structuredPostal.postCode ? postcodeRE.test(structuredPostal.postCode || '') : false;

    const isValidPOBox = () => {
      return (structuredPostal.poBox && structuredPostal.suburb && validPostcode);
    };
    const isValidResAddress = () => {
      return (structuredPostal.streetNumber && structuredPostal.street && structuredPostal.streetTypeId && structuredPostal.suburb && validPostcode);
    };

    let status = structuredPostal.poBox ? isValidPOBox() : isValidResAddress();
    let msg = status ? '' : 'Please provide either PO Box, Suburb and Postcode or Street Number, Street Name, Suburb and Postcode.';

    return { status, msg };
  }

  onEmitStructuredPostal(structuredPostal: any) {
    this.applicantDetails.structuredPostal = structuredPostal;
  }

  showSameAsApplicantLinkInCorrespondenceDetailsComponent() {
    return ['', undefined, null].indexOf(this.applicantDetails.postalAddress) === -1;
  }

  displayErrorMessage(): string {
    this.emailControl.markAsTouched();
    this.phoneNumberControl.markAsTouched();
    this.mobileNumberControl.markAsTouched();
    this.firstNameControl.markAsTouched();
    this.lastNameControl.markAsTouched();
    this.postalAddressControl.markAsTouched();
    this.abnNumberControl.markAsTouched();
    this.companyNameControl.markAsTouched();
    this.positionControl.markAsTouched();
    if (this.accountNoControl) {
      this.accountNoControl.markAsTouched();
    }

    // let errorText = this.postalAddress.displayErrorMessage();
    let errorText = '';

    if (this.applicantDetails.postalAddress) {
      errorText += this.isValidStructuredPostal(this.applicantDetails.structuredPostal).msg;
    }

    //if ((this.isGuestUserLoggedIn() && !this.isNonWorks && (!this.titles.selectedItemId || this.titles.selectedItemId === '0'))) {
    // errorText += 'Please select ' + this.applicantLabel + '\'s Title' + '<br>';
    // }

    if (this.applicantLabel === 'Consultant') {
      if (this.applicantDetails.currentConsultantSelectedItemId === 0) {
        errorText += 'Please select Consultant' + '<br>';
      }
    }

    if (this.companyNameControl.invalid) {
      if (this.companyNameControl.hasError('maxlength')) {
        errorText += 'Company Name cannot exceed ' + this.companyNameControlLength + ' characters' + '<br>';
      }
      if (this.companyNameControl.hasError('required')) {
        errorText += 'Please enter Company Name' + '<br>';
      }
    }

    if (this.isTechCSOUserLoggedIn()) {
      if (this.accountNoControl && this.accountNoControl.invalid) {
        errorText += 'Please enter valid account number' + '<br>';
      }
      if (!this.applicantDetails.postalAddress) {
        errorText += 'Please validate account number' + '<br>';
      }
    }

    if (this.isGuestUserLoggedIn() && !this.isNonWorks) {
      if (this.firstNameControl.invalid) {
        if (this.firstNameControl.hasError('maxlength')) {
          errorText += this.applicantLabel + '\'s First Name cannot exceed ' +
            this.firstNameControlLength + ' characters' + '<br>';
        }

        if (this.firstNameControl.hasError('required')) {
          errorText += 'Please enter ' + this.applicantLabel + '\'s First Name' + '<br>';
        }
      }

      if (this.lastNameControl.invalid) {
        if (this.lastNameControl.hasError('maxlength')) {
          errorText += this.applicantLabel + '\'s Last Name cannot exceed ' +
            this.firstNameControlLength + ' characters' + '<br>';
        }

        if (this.lastNameControl.hasError('required')) {
          errorText += 'Please enter ' + this.applicantLabel + '\'s Last Name' + '<br>';
        }
      }
    }
    if (!this.isNonWorks) {
      if (this.phoneNumberControl.invalid) {
        if (this.phoneNumberControl.hasError('maxlength')) {
          errorText += this.applicantLabel + '\'s Phone Number cannot exceed ' +
            this.phoneNumberControlMaxLength + ' characters' + '<br>';
        }

        if (this.phoneNumberControl.hasError('minlength')) {
          errorText += this.applicantLabel + '\'s Phone Number should be at least ' +
            this.phoneNumberControlMinLength + ' characters' + '<br>';
        }

        if (this.phoneNumberControl.hasError('required') && this.isLandLineMandatory) {
          errorText += 'Please enter ' + this.applicantLabel + '\'s Phone Number' + '<br>';
        }

        if (this.phoneNumberControl.hasError('pattern')) {
          errorText += 'Please enter numbers only in ' + this.applicantLabel + '\'s phone number' + '<br>';
        }
      }

      if (this.mobileNumberControl.invalid) {
        if (this.mobileNumberControl.hasError('maxlength')) {
          errorText += this.applicantLabel + '\'s Mobile Number should be ' +
            this.mobileNumberControlMaxLength + ' characters' + '<br>';
        }

        if (this.mobileNumberControl.hasError('minlength')) {
          errorText += this.applicantLabel + '\'s Mobile Number should be ' +
            this.mobileNumberControlMinLength + ' characters' + '<br>';
        }

        if (this.mobileNumberControl.hasError('required') && this.isMobileMandatory) {
          errorText += 'Please enter ' + this.applicantLabel + '\'s Mobile Number' + '<br>';
        }

        if (this.mobileNumberControl.hasError('pattern')) {
          errorText += 'Please enter numbers only in ' + this.applicantLabel + '\'s Mobile number' + '<br>';
        }
      }

      if (this.emailControl.invalid) {
        if (this.emailControl.hasError('maxlength')) {
          errorText += this.applicantLabel + '\'s Email cannot exceed ' + this.emailControlLength + ' characters' + '<br>';
        }
        if (this.emailControl.hasError('pattern')) {
          errorText += 'Please enter a valid ' + this.applicantLabel + '\'s Email' + '<br>';
        }
        if (this.emailControl.hasError('required')) {
          errorText += 'Please enter ' + this.applicantLabel + '\'s Email' + '<br>';
        }
      }
    }
    if (this.applicantLabel === 'Consultant') {
      if (this.consultantRefControl.invalid) {
        if (this.consultantRefControl.hasError('maxlength')) {
          errorText += 'Consultant\'s Reference cannot exceed ' + this.consultantRefControlLength + ' characters' + '<br>';
        }
        if (this.consultantRefControl.hasError('required')) {
          errorText += 'Please enter Consultant Reference' + '<br>';
        }
      }
    }

    if (this.isHydrant) {
      if (this.abnNumberControl.invalid) {
        if (this.abnNumberControl.hasError('maxlength')) {
          errorText += 'ABN Number cannot exceed ' + this.abnNumberControlLength + ' characters' + '<br>';
        }
        if (this.abnNumberControl.hasError('required')) {
          errorText += 'Please enter ABN Number' + '<br>';
        }
      }

      if (this.positionControl.invalid) {
        if (this.positionControl.hasError('maxlength')) {
          errorText += 'Position cannot exceed ' + this.positionControlLength + ' characters' + '<br>';
        }
        if (this.positionControl.hasError('required')) {
          errorText += 'Please enter Position' + '<br>';
        }
      }
    }

    this.markValidationControlsAsUntouched();

    return errorText;
  }

  get readOnlyTitle(): string {
    return this.applicantDetails.title;
  }

  clearTitle() {
    if (this.titles) {
      this.titles.selectedItemId = 0;
    }
  }

  get getCssClass(): string {
    //if (this.isReadOnly) {
      return 'form-control';
    //}
    //return 'no-border col-md-12';
  }

  get accountNumberClass(): string {
    return !(this.isTechCSOUserLoggedIn() || this.isGuestUserLoggedIn()) ? 'borderless-ro' : 'form-control';
  }

  markValidationControlsAsUntouched() {
    this.emailControl.markAsUntouched();
    this.phoneNumberControl.markAsUntouched();
    this.mobileNumberControl.markAsUntouched();
    this.firstNameControl.markAsUntouched();
    this.lastNameControl.markAsUntouched();
    this.postalAddressControl.markAsUntouched();
    this.abnNumberControl.markAsUntouched();
    this.companyNameControl.markAsUntouched();
    this.positionControl.markAsUntouched();
    if (this.accountNoControl) {
      this.accountNoControl.markAsUntouched();
    }

    if (this.postalAddress) {
      this.postalAddress.markValidationControlsAsUntouched();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/applicant-details/applicant-details.component.ts